/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
import { ProjectCreateDrawerConsumer } from '@jira/project-create__drawer-context/src/index.tsx';
import { MODAL_ID } from '@jira/navigation-apps__atlassian-navigation-ui/src/constants.tsx';
import { useCreateProjectPermission } from '@jira/platform__services-nav-item-service/src/services/create-project-permisson/index.tsx';
import type { OpenDrawerMethod } from '@jira/navigation-apps__project-create-drawer/src/types.tsx';
import { useSwitchModals } from '@jira/platform__controllers-switch-modals/src/index.tsx';

export const ProjectCreateDrawerOpener = ({
	open,
	close,
	setOnCloseCallback,
}: {
	open?: OpenDrawerMethod;
	close: () => void;
	setOnCloseCallback: (close: () => void) => void;
}): null => {
	const [{ canCreateClassicProject }] = useCreateProjectPermission();

	useEffect(() => {
		open &&
			// eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
			open({
				source: 'navigationNext',
				isNextGen: !canCreateClassicProject,
			});

		setOnCloseCallback && setOnCloseCallback(close);

		// oxlint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return null;
};

export const Projects = (): React.JSX.Element | null => {
	const [isProjectCreateDrawerOpen, { off: closeProjectCreateDrawer }] = useSwitchModals(
		MODAL_ID.PROJECT_CREATE,
	);

	if (!isProjectCreateDrawerOpen) {
		return null;
	}

	// ProjectCreateDrawerProvider is in page container/navigaiton
	return (
		<ProjectCreateDrawerConsumer>
			{({ methods: { open, setOnCloseCallback } }) => (
				<ProjectCreateDrawerOpener
					open={open}
					close={closeProjectCreateDrawer}
					setOnCloseCallback={setOnCloseCallback}
				/>
			)}
		</ProjectCreateDrawerConsumer>
	);
};
